import { Fade, Slide } from 'react-reveal';
import Customer from '../components/Customer';
import '../styles/about.css';
import { useNavigate } from 'react-router-dom';
import { ABOUT_SUB_TITLE, ABOUT_US, COMMERCIAL_TEXT, CUSTOMERS_TITLE, MISSION, RESIDENTIAL_TEXT, RESTAURANT_TEXT, VISION } from '../constants';

const About = () => {
    const navigate = useNavigate();

    const BASE_URL = process.env.NODE_ENV === 'development' ?
        process.env.REACT_APP_BASE_URL : process.env.REACT_APP_BASE_URL;

    const handleContact = () => {
        navigate('/contact');
        // window.location.href = `${BASE_URL}/contact`;
    }

    return (
        <div className="about container-fluid mx-0 px-0">
            <div className="row mx-0 px-0">
                <img className="img-fluid px-0" src="/assets/images/about/banner.jpg" alt="" />
                {/* <img className="img-fluid px-0" src="https://images.unsplash.com/photo-1600508774634-4e11d34730e2?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8aW50ZXJpb3IlMjBkZXNpZ24lMjBvZmZpY2V8ZW58MHwwfDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60" alt="" /> */}
            </div>

            {/* Start container */}
            <div className="container">
                <div className="row mx-0 py-5 my-3">
                    <Fade delay={1000} duration={1500}>
                        <div id="about-minganic">
                            <p align="center" className="dark-chocolate heading-2">About Minganic</p>
                            <p align="center" className="chocolate content-2 px-5">
                                {ABOUT_US}
                            </p>
                        </div>
                    </Fade>
                </div>
                {/* Start - Mission Vision */}
                <div className="row middle mx-0 px-0">
                    <div className="col-12 px-0 mx-0 col-md-6">
                        <img src="/assets/images/about/mission.jpg" alt="" />
                    </div>

                    <div className="col-12 px-0 mx-0 col-md-6 d-flex flex-column justify-content-center align-items-center">
                        <div>
                            <Fade distance='10%' right delay={1000} duration={1500}>
                                <p className="dark-chocolate heading-1" align="center">Our Mission</p>
                                <p className="chocolate content-1 px-5 pt-1" align="center">
                                    {MISSION}
                                </p>
                            </Fade>
                        </div>
                        {/* </div>

                    <div className="col-12 px-0 mx-0 col-md-6 d-flex flex-column justify-content-center align-items-center"> */}
                        <div>
                            <Fade distance='10%' left delay={1000} duration={1500}>
                                <p className="dark-chocolate heading-1" align="center">Our Vision</p>
                                <p className="chocolate content-1 px-5 pt-1" align="center">
                                    {VISION}
                                </p>
                            </Fade>
                        </div>
                    </div>
                    {/* End - Mission Vision */}

                    <hr className='mt-5 d-md-none' />

                    {/* Start - Category Description */}
                    <Fade>
                        <p className="dark-chocolate heading-1 pt-3 py-md-5" align="center">
                            {ABOUT_SUB_TITLE}
                        </p>
                    </Fade>
                    <div className="row mx-0 px-0">
                        <div className="col-12 py-5 py-md-0 px-5 mx-0 col-md-6 d-flex flex-column justify-content-center align-items-center">
                            <Slide left>
                                <p className='dark-chocolate heading-1' align="center">
                                    Commercial Interiors
                                </p>
                                <p className='light-chocolate content-1' align="center">
                                    {COMMERCIAL_TEXT}
                                </p>
                            </Slide>
                        </div>
                        <div className="col-12 px-0 mx-0 col-md-6 order-1 order-md-2">
                            <Slide right>
                                <img className="img-fluid" src="/assets/images/about/office.jpg" alt="" />
                            </Slide>
                        </div>
                    </div>

                    <div className="row mx-0 px-0">
                        <div className="col-12 px-0 mx-0 col-md-6 order-2 order-md-1">
                            <Slide left>
                                <img className="img-fluid" src="/assets/images/about/resident.jpg" alt="" />
                            </Slide>
                        </div>
                        <div className="col-12 py-5 py-md-0 px-5 mx-0 col-md-6 order-1 order-md-2 d-flex flex-column justify-content-center align-items-center">
                            <Slide right>
                                <p className='dark-chocolate heading-1' align="center">
                                    Residential Interiors
                                </p>
                                <p className='light-chocolate content-1' align="center">
                                    {RESIDENTIAL_TEXT}
                                </p>
                            </Slide>
                        </div>
                    </div>

                    <div className="row mx-0 px-0 pb-5">
                        <div className="col-12 py-5 py-md-0 px-5 mx-0 col-md-6 d-flex flex-column justify-content-center align-items-center">
                            <Slide left>
                                <p className='dark-chocolate heading-1' align="center">
                                    Restaurant & Hotels
                                </p>
                                <p className='light-chocolate content-1' align="center">
                                    {RESTAURANT_TEXT}
                                </p>
                            </Slide>
                        </div>
                        <div className="col-12 px-0 mx-0 col-md-6 order-1 order-md-2">
                            <Slide right>
                                <img className="img-fluid" src="/assets/images/about/restaurant.jpg" alt="" />
                            </Slide>
                        </div>
                    </div>
                    {/* End - Category Description */}

                    {/* <div className="col-12 px-0 mx-0 py-5 contact-col">
                        <p align="center" className="dark-chocolate heading-2 py-3">Make your dream design come true</p>
                        <button className="contact-btn content-2" type="submit">contact us<img id="send-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" /></button>
                    </div> */}

                </div>

                {/* Start - Our Customers Card */}

                {/* <div className="customer-card">
                    <div className="image-stack">
                        <div className="image-stack__item image-stack__item--top">
                            <img src="https://images.unsplash.com/photo-1634926878768-2a5b3c42f139?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=456&q=80" alt="" />
                        </div>
                        <div className="image-stack__item image-stack__item--bottom">
                            <img src="https://images.unsplash.com/photo-1622372738946-62e02505feb3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=532&q=80" alt="" />
                        </div>
                        <p>Text can go down here yabba dabba do</p>
                    </div>
                </div> */}
                {/* End - Our Customers Card */}

                {/* Start - Our Customers Card */}
                {/* <p className="dark-chocolate heading-1 pt-5 py-md-5" align="center">
                    Our loyal customers
                </p>
                <div className="row align-items-center justify-content-center py-5">
                    <div className="col-12 col-md-5">
                        <div className="customer-card">
                            <div className="image-stack">
                                <div className="image-stack__item image-stack__item--top">
                                    <img src="https://images.unsplash.com/photo-1634926878768-2a5b3c42f139?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=456&q=80" alt="" />
                                </div>
                                <div className="image-stack__item image-stack__item--bottom">
                                    <img src="https://images.unsplash.com/photo-1622372738946-62e02505feb3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=532&q=80" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-5">
                        <img id="double-quotes" src="/assets/icons/double-quotes.svg" alt="" />
                        <p id="double-quotes-text" className="content-1">
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptate illum quos consequuntur, in laboriosam, similique nihil temporibus eveniet excepturi velit animi laborum reprehenderit facere obcaecati. Eligendi atque cupiditate nesciunt perspiciatis!

                        </p>
                        <span id="customer-name" className="content-1">- Lorem Ipsum</span>

                    </div>
                    <div className="col-md-2 d-flex justify-content-center align-self-end">
                        <div id="arrow-div">
                            <img id="arrow-left" src="/assets/icons/arrow-left.svg" alt="" />
                            <img id="arrow-right" src="/assets/icons/arrow-right.svg" alt="" />
                        </div>
                    </div>
                </div> */}
                {/* End - Our Customers Card */}

                {/* Start - Copy of customer */}
                <Fade>
                    <p className="dark-chocolate heading-1 pt-5 py-md-5" align="center">
                        {CUSTOMERS_TITLE}
                    </p>
                </Fade>
                <Fade>
                    <Customer />
                </Fade>
                {/* End - Copy of customer */}

                {/* Start - Contact Us */}
                <div className="col-12 px-0 mx-0 py-5 contact-col">
                    <Fade duration={1500}>
                        <p align="center" className="dark-chocolate heading-1 py-3">
                            Make your dream design come true
                        </p>
                        <button className="contact-btn content-2 button-fill" onClick={handleContact}>
                            contact us<img id="send-arrow" src="/assets/icons/arrow_right_icon.svg" alt="arrow" />
                        </button>
                    </Fade>
                </div>
                {/* End - Contact Us */}

            </div>  {/* End container */}
        </div>  // End container-fluid
    );
}

export default About;